import { View, ViewProps, ViewStyle } from "react-native"

export interface LinearGradientProps extends ViewProps {
  colors: string[]
  start?: { x: number; y: number }
  end?: { x: number; y: number }
  style?: ViewStyle
}

/**
 * Web-native LinearGradient implementation using CSS gradients
 *
 * Provides compatibility with react-native-linear-gradient API
 */
export default function LinearGradient({
  colors,
  start = { x: 0, y: 0 },
  end = { x: 0, y: 1 },
  style,
  children,
  ...props
}: LinearGradientProps) {
  // Convert start/end coordinates to CSS gradient direction
  // React Native uses 0,0 (top-left) to 1,1 (bottom-right) coordinate system
  const deltaX = end.x - start.x
  const deltaY = end.y - start.y

  // Calculate angle in degrees (CSS uses clockwise from top)
  const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI) + 90

  const colorStops = colors.join(", ")

  const gradientStyle: ViewStyle & { background?: string } = {
    background: `linear-gradient(${angle}deg, ${colorStops})`,
  }

  return (
    <View style={[gradientStyle, style]} {...props}>
      {children}
    </View>
  )
}
